<template>
  <v-app>
    <SideNavigationVue
      @minimizeMenu="isMenuMinimized = $event"
      :isMenuMinimized="isMenuMinimized"
      @slectedTab="AddTabs($event)"
    />

    <NavBar @toggleMenu="toggleMenuListener($event)" />
    <!-- Sizes your content based upon application components -->
    <v-main class="main-bgcol ma-1 mb-12">
      <!-- Provides the application the proper gutter -->

      <v-card class="ma-1" outlined>
        <v-chip small label class="pa-0 ma-1" color="primary">
          <v-icon
            @click="$router.go(-1)"
            class="me-2 ms-2"
            title="Click to go Back"
            >mdi-arrow-left-circle</v-icon
          >

          <v-icon
            class="me-2"
            title="Click to reload this page"
            @click="reload()"
            >mdi-refresh-circle</v-icon
          >
        </v-chip>
        <v-chip
          small
          v-for="(item, i) in selectedTabs"
          :key="item.title"
          :close="item.close"
          label
          class="ma-1"
          :color="$route.path === item.path ? 'primary' : ''"
          @click:close="closeTabs(item, i)"
          @click="$router.push(item.path)"
        >
          {{ item.title }}
        </v-chip>
      </v-card>
      <!-- <v-snackbar
        timeout="2000"
        :value="alert.show"
        :color="alert.color"
        text
        elevation="3"
        absolute
        class="mt-15"
        right
        top
      >
        <strong>{{ alert.message }}</strong>
      </v-snackbar> -->
      <keep-alive :include="data">
        <router-view @trigger-reload="reload()" ref="route" v-if="reloaddata" />
      </keep-alive>
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import SideNavigationVue from "../components/navigations/SideNavigation.vue";
import NavBar from "@/components/navigations/NavBar.vue";
// import NavBarLeft from "@/components/navigations/NavBarLeft.vue";
import Footer from "@/components/navigations/Footer.vue";
export default {
  name: "Layout",
  data: () => {
    return {
      profiledata: [],
      data: ["Dashboard"],
      isMenuMinimized: false,
      reloaddata: true,
      keyvalue: 0,
      $refs: {},
      selectedTabs: [
        {
          title: "Dashboard",
          path: "/home",
          close: false,
        },
      ],
    };
  },

  components: {
    SideNavigationVue,
    Footer,
    NavBar,
    // NavBarLeft
  },
  computed: {
    ...mapState(["alert"]),
    checkroute() {
      return this.data.includes(this.$route.name) ? true : false;
    },
  },
  watch: {
    data(val) {
      console.log("data tabs", val);
    },
  },
  mounted() {
    // const cache = this.$refs.route.$vnode;
    // console.log("cache", cache);
  },
  methods: {
    reload() {
      console.log("routeData", this.$route);
      this.reloaddata = false;
      const data = this.$router.currentRoute.matched[1].components.default.name;
      if (this.data.includes(data)) {
        this.data = this.data.filter((ele) => ele != data);
        console.log(this.data);
        setTimeout(() => {
          this.reloaddata = true;
          this.data.push(data);
        }, 300);
      } else {
        setTimeout(() => {
          this.reloaddata = true;
        }, 300);
      }
    },
    closeTabs(item, i) {
      console.log(item);
      this.selectedTabs.splice(i, 1);
      this.data.splice(i, 1);
      const lastTab = this.selectedTabs[this.selectedTabs.length - 1];
      this.$router.push(lastTab.path);
    },
    AddTabs(tabs) {
      console.log("tabs", this.$route);
      console.log("tabsdeta", this.selectedTabs);
      // const compName =
      //   this.$router.currentRoute.matched[1].components.default.name;
      const i = this.selectedTabs.findIndex((e) => e.title === tabs.title);
      if (i > -1) {
        console.log("..");
      } else {
        if (this.selectedTabs.length != 6) {
          this.data.push(tabs.title);
          this.selectedTabs.push(tabs);
        } else if (this.selectedTabs.length == 6) {
          this.selectedTabs.splice(1, 1);
          this.selectedTabs.push(tabs);
          this.data.push(tabs.title);
        }
      }
    },
    getProfile() {
      console.log("getProfile*****");
      this.$store
        .dispatch("Authentication/getProfile")
        .then((res) => {
          console.log("getProfile**", res.data.data);
          if (Array.isArray(res.data.data)) {
            this.profiledata = res.data.data;

            sessionStorage.setItem(
              "App_Language",
              this.profiledata[0].Language
            );
            this.$i18n.locale = this.profiledata[0].Language;
          }
        })
        .catch((err) => console.error(err));
    },
    toggleMenuListener(data) {
      this.isMenuMinimized = data;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
.v-application--wrap > section {
  flex: 1 1 auto;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100%;
  position: relative;
}

.main-bgcol {
  background-color: $background-color !important;
}
@media only screen and (max-width: 540px) {
}
</style>
